import { useEffect } from "react";
import { submitNPS } from "../../services/api";
import { appConstants } from "../../utils/constants";
import { useDashboardContext } from "../customhook/dashboardHook";

export const SubmitFeedback = ({ children }) => {
  const { dashboardStates, setDashboardStates } = useDashboardContext();

  useEffect(() => {
    if (dashboardStates.isSubmitClicked) {
      setDashboardStates((previousState) => {
        return {
          ...previousState,
          isSubmitloading: true,
        };
      });

      const submitFormData = {
        mobileNumber: dashboardStates.mobileNumber,
        conceptCode: localStorage.getItem(appConstants.conceptCode),
        qrValue: localStorage.getItem(appConstants.qrValue),
        surveyType: localStorage.getItem(appConstants.surveyType),
        consent: dashboardStates.concent,
        sourceChannel: dashboardStates.sourceChannel,
        feedbacks: [
          {
            remarks: dashboardStates.feedbackRemark,
            questionId: dashboardStates.childQuestionId,
            feedbackValue: dashboardStates.rating,
          },
        ],
      };

      submitNPS({ npsFormData: submitFormData }).then((response) => {
        if (response !== null && response !== undefined) {
          if (response?.status === 200) {
            setDashboardStates((previousState) => {
              return {
                ...previousState,
                isSubmittedMessage: appConstants.helpingUs,
                isSubmitted: true,
                isSubmitClicked: false,
                isSubmitloading: false,
              };
            });
          } else if (response?.status === 500) {
            setDashboardStates((previousState) => {
              return {
                ...previousState,
                isSubmittedMessage: appConstants.alreadyRated,
                isSubmitted: true,
                isSubmitClicked: false,
                isSubmitloading: false,
              };
            });
          }
          return response;
        }
      });
    }
  }, [
    dashboardStates.childQuestionId,
    dashboardStates.isSubmitClicked,
    dashboardStates.rating,
    dashboardStates.feedbackRemark,
    dashboardStates.mobileNumber,
    setDashboardStates,
    dashboardStates.concent,
    dashboardStates.sourceChannel,
  ]);

  return children;
};
